import { PreviewError, type Bytes } from './previewCrypto';

/*
 * ⚠️ **Nicht `server/multipart.ts`.** Das baut Anfragen zum Hochladen; hier wird eine Antwort
 * zerlegt, und ihre Teile sind binär. Übernommen von Ink (`INK/src/preview/multipart.ts`).
 */

export interface Part {
  name: string;
  body: Bytes;
}

const latin1 = (bytes: Uint8Array): string => {
  let s = '';
  for (let i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]);
  return s;
};

const indexOf = (hay: Uint8Array, needle: Uint8Array, from: number): number => {
  outer: for (let i = from; i <= hay.length - needle.length; i++) {
    for (let j = 0; j < needle.length; j++) if (hay[i + j] !== needle[j]) continue outer;
    return i;
  }
  return -1;
};

/**
 * `multipart/mixed` nach RFC 2046, auf Bytes. Gesucht wird stets `\r\n--<Grenze>`, so dass ein
 * `--` im Inhalt nichts trennt.
 */
export function splitMultipart(contentType: string, body: Bytes): Part[] {
  const m = /boundary=(?:"([^"]+)"|([^;\s]+))/i.exec(contentType);
  if (!m) throw new PreviewError('format', 'keine Grenze');
  const boundary = m[1] ?? m[2];
  const delimiter = new TextEncoder().encode(`\r\n--${boundary}`);

  // Die erste Grenze darf ohne vorangehendes CRLF am Anfang stehen.
  let at = indexOf(body, delimiter.subarray(2), 0);
  if (at < 0) throw new PreviewError('format', 'Grenze fehlt');
  at += delimiter.length - 2;

  const parts: Part[] = [];
  for (;;) {
    // Nach der Grenze: `--` heißt Ende, sonst CRLF und die Kopfzeilen des Teils.
    if (body[at] === 0x2d && body[at + 1] === 0x2d) return parts;
    const headEnd = indexOf(body, new Uint8Array([13, 10, 13, 10]), at);
    if (headEnd < 0) throw new PreviewError('format', 'Kopf ohne Ende');
    const head = latin1(body.subarray(at, headEnd));
    const next = indexOf(body, delimiter, headEnd + 4);
    if (next < 0) throw new PreviewError('format', 'Teil ohne Ende');
    const name = /name="([^"]*)"/i.exec(head)?.[1] ?? '';
    parts.push({ name, body: body.subarray(headEnd + 4, next) });
    at = next + delimiter.length;
  }
}
